import React, { Suspense } from 'react'
import PublicPageLoader from '../../component/Elements/publicPageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const Recovery = lazyWithRetry(() => import(/* webpackChunkName: "recovery" */'../../component/Recovery'))

const RecoveryPage = React.memo(() => {
	return (
		<Suspense fallback={<PublicPageLoader className="authPage" />}>
			<Recovery />
		</Suspense>
	)
})

RecoveryPage.displayName = 'RecoveryPage'
export default RecoveryPage
